import { Link } from 'react-router-dom';

const NotFound = () => (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center px-4">
        <h1 className="text-6xl font-bold text-heading mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-default mb-4">Page Not Found</h2>
        <p className="text-body mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary-hover transition-colors"
        >
          Return Home
        </Link>
      </div>
    </div>
  );

export default NotFound; 